(() => {
  const getImage = (p) => {
    const f = p?.featured_image;
    if (typeof f === 'string') return f;
    if (f?.url) return f.url;
    if (f?.src) return f.src;
    const i = p?.images?.[0];
    return typeof i === 'string' ? i : (i?.src || i?.url || '');
  };

  const productUrl = (p) => p?.url || (p?.handle ? `/products/${p.handle}` : '#');

  const productPrice = (p) => {
    const raw = p?.price ?? p?.variants?.[0]?.price ?? 0;
    let n = Number(raw);
    if (!Number.isFinite(n)) return '';
    if (typeof raw === 'number' && Number.isInteger(raw)) n = raw / 100;
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(n);
  };

  const escapeHTML = (value = '') => String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  function cardHTML(p) {
    const image = getImage(p);
    const title = escapeHTML(p?.title || '');
    const url = productUrl(p);
    return `<a class="chm-related-card" href="${url}">
      <span class="chm-related-card__image-wrap">${image ? `<img class="chm-related-card__image" src="${image}" alt="${title}" loading="lazy">` : ''}</span>
      <span class="chm-related-card__title">${title}</span>
      <span class="chm-related-card__price">${productPrice(p)}</span>
    </a>`;
  }

  async function buildMixedRecommendations(component) {
    if (!component || component.dataset.chmMixedLoaded === 'true' || component.dataset.chmMixedLoaded === 'loading') return;
    component.dataset.chmMixedLoaded = 'loading';
    const productId = component.dataset.productId;
    if (!productId) { component.dataset.chmMixedLoaded = 'false'; return; }

    try {
      const [relatedRes, basicsRes] = await Promise.all([
        fetch(`/recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=8&intent=related`, { credentials: 'same-origin' }),
        fetch('/collections/basique-vetements/products.json?limit=12', { credentials: 'same-origin' })
      ]);
      const relatedJson = relatedRes.ok ? await relatedRes.json() : { products: [] };
      const basicsJson = basicsRes.ok ? await basicsRes.json() : { products: [] };
      const related = relatedJson.products || [];
      const basics = basicsJson.products || [];
      const current = String(productId).split('/').pop();
      const used = new Set([current]);
      const chosen = [];
      const push = (p) => {
        const id = String(p?.id ?? '');
        if (!p || !id || used.has(id)) return false;
        used.add(id);
        chosen.push(p);
        return true;
      };

      if (related[0]) push(related[0]);
      basics.find(push);
      related.slice(1).find(push);
      basics.find(push);
      [...related, ...basics].forEach((p) => { if (chosen.length < 4) push(p); });

      if (!chosen.length) { component.dataset.chmMixedLoaded = 'false'; return; }
      const html = `<div class="chm-related-grid">${chosen.slice(0, 4).map(cardHTML).join('')}</div>`;
      component.querySelectorAll('.resource-list').forEach((list) => {
        list.className = 'resource-list chm-related-grid-wrap';
        list.innerHTML = html;
        list.dataset.hasRecommendations = 'true';
      });
      component.dataset.chmMixedLoaded = 'true';
    } catch (_) {
      component.dataset.chmMixedLoaded = 'false';
    }
  }

  function apply(root = document) {
    root.querySelectorAll?.('product-recommendations').forEach(buildMixedRecommendations);
  }

  const start = () => {
    apply();
    document.addEventListener('shopify:section:load', (e) => apply(e.target));
    const observer = new MutationObserver(() => apply());
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
